export default "__VITE_ASSET__DV$jbVkb__"